// --------------------- Import Globais ---------------------
import { useState, useEffect, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
  Space,
  Dropdown,
} from "antd";
import type { TableProps } from "antd/es/table";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import SettingsIcon from "@mui/icons-material/Settings";
// --------------------- Import Styles ---------------------
import { BotoesAcoes, Container } from "../ViewGerenciarPostagens/styles";
// --------------------- Import Hooks ---------------------
import { useConverterProprietario } from "./hooks/useConverterProprietario";

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import ModalEditar from "./components/ModalEditar";
import ModalExcluir from "./components/ModalExcluir";
import ModalAdicionar from "./components/ModalAdicionar";
import LoadingSpin from "../../uteis/LoadingSpin";

// --------------------- Import Uteis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { getMenuItemsAll } from "./constants/itemsActionAll";
import { Pessoa } from "../../interfaces/Pessoa";
import { useBuscarPessoas } from "./hooks/useBuscarPessoas";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../uteis/mensagens/useNotification";
import { buscarEtiquetasService } from "../../services/buscarEtiquetasService";
// ---------------------  ---------------------

export default function ViewGerenciarPessoas() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO
  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Armazena o valor da origem da pessoa
  const [pessoaId, setPessoaId] = useState<number | null>(null);

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);


  const { pessoas, isLoading, fetchPessoas, setPessoas } = useBuscarPessoas();
  const [leadId, setLeadId] = useState<number | null>(null);
  const [rowAtual, setRowAtual] = useState<any>(null);




  const {
    converterProprietario,
    isLoading: isLoadingConverterProp,
    success,
    resetSuccess,
    error,
    resetError,
    warning,
    resetWarning,
  } = useConverterProprietario();

  // State de abertura e fechamento do modal (Adicionar Pessoa)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  // Funçao para abrir o modal (Adicionar Apartamento)
  const adicionarModal = () => {
    setIsModalAdicionarOpen(true);
  };

  // Funçao para fechar o modal (Editar Adicionar)
  const handleAdicionarFechar = () => {
    setIsModalAdicionarOpen(false);
  };

  // State de abertura e fechamento do modal (Editar Pessoa)
  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const editarModal = () => {
    setIsModalEditarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleEditarFechar = () => {
    setIsModalEditarOpen(false);
  };

  // State de abertura e fechamento do modal (Excluir Pessoa)
  const [isModalExcluirOpen, setIsModalExcluirOpen] = useState(false);

  // Funçao para abrir o modal (Editar Pessoa)
  const excluirModal = () => {
    setIsModalExcluirOpen(true);
  };

  // Funçao para fechar o modal (Excluir Pessoa)
  const handleExcluirFechar = () => {
    setIsModalExcluirOpen(false);
  };



  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    nome?: string[] | null;
    celular?: string[] | null;
    
   
    status?: string[] | null;
    observacoes?: string[] | null;
    etiquetas?: string[] | null;
    tipo?: string[] | null;
  }>({
    nome: null,
    celular: null,
    
   
    status: null,
    etiquetas: null,
    observacoes: null,
    tipo: null,
  });
  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        nome: novoFiltro.nome ? [novoFiltro.nome] : null,
        celular: novoFiltro.celular ? [novoFiltro.celular] : null,
      
        status: novoFiltro.status ? [novoFiltro.status] : null,
        etiquetas: novoFiltro.etiquetas ? (Array.isArray(novoFiltro.etiquetas) ? novoFiltro.etiquetas : [novoFiltro.etiquetas]) : null,

        observacoes: novoFiltro.observacoes ? [novoFiltro.observacoes] : null,
        tipo: novoFiltro.tipo ? [novoFiltro.tipo] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      nome: filters.nome as string[] | null,
      celular: filters.celular as string[] | null,
      
     
      status: filters.status as string[] | null,
      etiquetas: filters.etiquetas as string[] | null,
      observacoes: filters.observacoes as string[] | null,
      tipo: filters.tipo as string[] | null,
    });

    const hasFilters = Boolean(
      filters.nome ||
        filters.celular ||
        filters.etiquetas ||
      
        filters.status ||
        filters.observacoes ||
        filters.tipo
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({
      nome: null,
      celular: null,
     
      
      etiquetas: null,
      status: null,
      observacoes: null,
      tipo: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  const allIds = useMemo(() => {
  const filteredPessoas = pessoas.filter((pessoa) => {
    return (
      (!filteredInfo.nome ||
        filteredInfo.nome.some((nome) =>
          String(pessoa.nome ?? "").includes(String(nome ?? ""))
        )) &&
      (!filteredInfo.celular ||
        filteredInfo.celular.some((celular) =>
          String(pessoa.celular ?? "").includes(String(celular ?? ""))
        )) &&
     (!filteredInfo.etiquetas ||
  filteredInfo.etiquetas.some((f) =>
    (pessoa.etiquetas ?? []).some((e) =>
      String(e.nome ?? "").toLowerCase().includes(String(f ?? "").toLowerCase())
    )
  )) &&


     
      (!filteredInfo.status ||
        filteredInfo.status.some((status) =>
          String(pessoa.status ?? "").includes(String(status ?? ""))
        )) &&
      (!filteredInfo.observacoes ||
        filteredInfo.observacoes.some((observacoes) =>
          String(pessoa.observacoes ?? "").includes(String(observacoes ?? ""))
        )) &&
      (!filteredInfo.tipo ||
        filteredInfo.tipo.some((tipo) =>
          String(pessoa.tipo ?? "").includes(String(tipo ?? ""))
        ))
    );
  });

  return filteredPessoas.map((pessoas) => pessoas.pessoaId);
}, [pessoas, filteredInfo]);


  const handleSelectAllClick = () => {
    if (selectedRowKeys.length === allIds.length) {
      setSelectedRowKeys([]);
    } else {
      setSelectedRowKeys(allIds);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const hasSelected = selectedRowKeys.length > 0;

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Editar
      case "1":
        editarModal();
        break;

      case "2":
        // Excluir
        excluirModal();
        break;
      case "3":
        // Converter Proprietários
        converterProprietario(selectedRowKeys);
        break;
    }
  };

  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
 

  // Exibe a notificação de Sucesso, Erro e Warning
  const { openNotificationWithIcon, contextHolder: contextHolderNotification } =
    useNotification();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    // Exibe a mensagem de sucesso
    if (success && !successDisplayed) {
      openNotificationWithIcon("success", "Sucesso", success);
      setSuccessDisplayed(true);
      fetchPessoas();
      // Limpa estado de sucesso após 3 segundos e recarrega a página
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
      }, 3000);
    }

    // Exibe a mensagem de erro
    if (error && !errorDisplayed) {
      openNotificationWithIcon("error", "Erro", error);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }

    // Exibe a mensagem de alerta
    if (warning && !warningDisplayed) {
      openNotificationWithIcon("warning", "Atenção", warning);
      setWarningDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setWarningDisplayed(false);
        resetWarning();
      }, 3000);
    }
  }, [
    success,
    error,
    warning,
    openNotificationWithIcon,
    errorDisplayed,
    successDisplayed,
    warningDisplayed,
    resetError,
    resetSuccess,
    navigate,
  ]);

  type EtiquetaOption = { id: number; nome: string; cor?: string | null };

const [etiquetasOptions, setEtiquetasOptions] = useState<EtiquetaOption[]>([]);

useEffect(() => {
  (async () => {
    const data = await buscarEtiquetasService();
    if (Array.isArray(data)) {
      setEtiquetasOptions(
        data
          .filter((e) => e.active === 1)
          .map((e) => ({ id: e.id, nome: e.nome, cor: e.cor ?? null }))
          .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
      );
    }
  })();
}, []);

const columns = Columns(
  onClick,
  setLeadId, // ✅ 2º argumento é setLeadId
  {
    nome: filteredInfo.nome,
    celular: filteredInfo.celular,
    status: filteredInfo.status,
    etiquetas: filteredInfo.etiquetas,
    observacoes: filteredInfo.observacoes,
    tipo: filteredInfo.tipo,
  },
  etiquetasOptions,
  setPessoas,
  setPessoaId,  // ✅ aqui é setPessoaId
  setRowAtual   // ✅ opcional
);



  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : isLoadingConverterProp ? (
        <LoadingSpin
          message="Convertendo Proprietários..."
          description="Esta ação pode levar alguns instantes. Aguarde, por favor..."
        />
      ) : (
        <>
          <>{contextHolderNotification}</>
          <Container>
            <Row>
              <Col span={5}>
                <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                  <a href={`/inicio`}>
                   
                  </a>
                </Flex>
              </Col>
              <Col span={12}>
                <Flex align="center" justify="center">
                  <HomeIcon color="primary" fontSize="large" />
                  <Title
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      fontSize: isMobile ? "1rem" : "2rem",
                      color: "rgb(0, 54, 68)",
                    }}
                    level={3}
                  >
                    Gerenciar Pessoas
                  </Title>
                </Flex>
              </Col>
            </Row>

            <Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "auto",
                  width: "90%",
                  gap: "20px",
                }}
              >
                <Space size="middle" style={{ marginLeft: "50px" }}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "auto",
                    }}
                    onClick={handleSelectAllClick}
                    type="primary"
                  >
                    {selectedRowKeys.length === allIds.length
                      ? "Desmarcar todas as pessoas"
                      : "Selecionar todas as pessoas"}
                  </Button>
                  <Dropdown
                    menu={{ items: getMenuItemsAll(), onClick }}
                    trigger={["click"]}
                  >
                    <BotoesAcoes>
                      <Space>
                        <SettingsIcon />
                      </Space>
                    </BotoesAcoes>
                  </Dropdown>
                </Space>

                <span>
                  {hasSelected
                    ? `Selecionado ${selectedRowKeys.length} pessoa(s)`
                    : ""}
                </span>

                <div style={{ display: "flex", gap: "20px" }}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "auto",
                    }}
                    onClick={adicionarModal}
                    type="primary"
                  >
                    + Pessoa
                  </Button>

                  {semFiltros ? (
                    <Button onClick={handleFilter} type="primary" disabled>
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button onClick={handleFilter} type="primary">
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </div>
              </div>
              <Col span={isMobile ? 5 : 1}></Col>

              <Col
                span={22}
                style={{
                  marginTop: isMobile ? 15 : 15,
                  marginBottom: isMobile ? 30 : 50,
                }}
              >
                <Flex
                  style={{
                    width: isMobile ? "auto" : "100%",
                    overflow: "auto",
                    marginLeft: 30,
                  }}
                >
                  <Table
                    rowKey="pessoaId"
                    columns={columns}
                    dataSource={pessoas}
                    onChange={onChange}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                    rowSelection={{ ...rowSelection }}
                  />
                </Flex>
              </Col>

              <Col span={1}></Col>
            </Row>

            <ModalAdicionar
              isModalOpen={isModalAdicionarOpen}
              handleFechar={handleAdicionarFechar}
            />
            <ModalEditar
              isModalOpen={isModalEditarOpen}
              handleFechar={handleEditarFechar}
              leadId={leadId}
            />
            <ModalExcluir
              isModalOpen={isModalExcluirOpen}
              handleFechar={handleExcluirFechar}
              leadId={leadId}
            />
          </Container>
        </>
      )}
    </>
  );
}
